import api from './services/api'
import { cnpj, email } from 'validacao-docs'
import {
  parse,
  isValid,
  format,
  startOfToday,
  differenceInDays,
  subYears
} from 'date-fns'
import { enGB } from 'date-fns/locale'

var utils = {
  applyDateFormat (data) {
    data = new Date(data)
    return (
      data.getDate() + '/' + (data.getMonth() + 1) + '/' + data.getFullYear()
    )
  },

  isValidDate (date, years) {
    if (typeof date === 'string' || date instanceof String) {
      if (years) {
        let today = startOfToday()
        today = subYears(today, years)
        const diff = differenceInDays(
          today,
          parse(date, 'P', new Date(), { locale: enGB })
        )
        if (diff < 0) {
          return false
        }
      } else {
        const today = startOfToday()
        const diff = differenceInDays(
          today,
          parse(date, 'P', new Date(), { locale: enGB })
        )
        if (diff < 0) {
          return false
        }
      }
      if (date.length !== '**/**/****'.length) {
        return false
      }
    } else {
      if (years) {
        let today = startOfToday()
        today = subYears(today, years)
        const diff = differenceInDays(today, date)
        if (diff < 0) {
          return false
        }
      } else {
        const today = startOfToday()
        const diff = differenceInDays(today, date)
        if (diff < 0) {
          return false
        }
      }
      if (format(date, 'dd/MM/yyyy').length !== '**/**/****'.length) {
        return false
      }
    }

    if (isValid(date)) {
      return true
    }
    const parsedDate = parse(date, 'P', new Date(), { locale: enGB })
    const isValidDate = isValid(parsedDate)
    return isValidDate
  },

  applyMask (name, value) {
    if (Array.isArray(name)) name = name[1]
    if (value) {
      value = value.replace(/[^a-z0-9]/gi, '')
      switch (name) {
        case 'CNPJ':
          return (
            value.substr(0, 2) +
            '.' +
            value.substr(2, 3) +
            '.' +
            value.substr(5, 3) +
            '/' +
            value.substr(8, 4) +
            '-' +
            value.substr(12, 2)
          )

        case 'CNAE':
          return (
            value.substr(0, 4) +
            '-' +
            value.substr(4, 1) +
            '/' +
            value.substr(5, 2)
          )

        case 'InscricaoEstadual':
          return value.substr(0, 8) + '-' + value.substr(8, 2)

        case 'CEP':
          return value.substr(0, 5) + '-' + value.substr(5, 3)

        case 'CPF':
          return (
            value.substr(0, 3) +
            '.' +
            value.substr(3, 3) +
            '.' +
            value.substr(6, 3) +
            '-' +
            value.substr(9, 2)
          )

        case 'Celular':
          value = '+' + value
          if (value.substr(0, 3) === '+55') {
            return (
              '+55(' +
              value.substr(3, 2) +
              ') ' +
              value.substr(5, 5) +
              '-' +
              value.substr(10, 4)
            )
          } else {
            value = value.replaceAll('+', '')
            return (
              '(' +
              value.substr(0, 2) +
              ') ' +
              value.substr(2, 5) +
              '-' +
              value.substr(7, 4)
            )
          }

        case 'Telefone':
          if (value.substr(0, 3) === '+55') {
            if (value.length > '+############'.length) {
              return (
                '(' +
                value.substr(3, 2) +
                ') ' +
                value.substr(5, 5) +
                '-' +
                value.substr(10, 4)
              )
            } else {
              return (
                '(' +
                value.substr(3, 2) +
                ') ' +
                value.substr(5, 4) +
                '-' +
                value.substr(9, 4)
              )
            }
          } else {
            if (value.length > '##########'.length) {
              return (
                '(' +
                value.substr(0, 2) +
                ') ' +
                value.substr(2, 5) +
                '-' +
                value.substr(7, 4)
              )
            } else {
              return (
                '(' +
                value.substr(0, 2) +
                ') ' +
                value.substr(2, 4) +
                '-' +
                value.substr(6, 4)
              )
            }
          }
        default:
          return value
      }
    }
  },

  formatSHOPToCompanyData (shopData) {
    const companyData = shopData.person.juridicPerson
    const address = shopData.person.personAddresses[0].address
    const representatives = companyData.legalRepresentatives.map((legalRepresentative) => legalRepresentative.physicalPerson)

    const company = {
      corporateName: companyData.legalName,
      fantasyName: companyData.tradingName,
      cnpj: companyData.cnpj,
      openingDate: companyData.openingDate,
      cnae: companyData.cnae,
      companyConstituition: companyData.constitution,
      monthlyBilling: companyData.monthlyIncome,
      operationType: companyData.fieldOfActivity,
      taxRegime: companyData.taxRegime,
      isTaxExempt: companyData.exemptFromTax,
      stateRegistration: companyData.stateRegistration,
      zipCode: address.zipCode,
      address: address.street,
      number: address.number,
      district: address.neighborhood,
      complement: address.complement,
      city: address.city,
      country: address.country,
      state: address.uf,
      ibgeCode: address.ibgeCode,
      representatives: representatives ? representatives.map((representative) => {
        const address = representative.person.personAddresses[0] && representative.person.personAddresses[0].address
        const phoneContact = representative.person.contacts.find((contact) => contact.category === 'principal' && contact.phone)
        const emailContact = representative.person.contacts.find((contact) => contact.category === 'principal' && contact.email)
        return {
          fullName: representative.name,
          socialName: representative.assumedName,
          motherName: representative.motherName,
          phone: phoneContact ? `+55${phoneContact.phone}` : '',
          email: emailContact ? emailContact.email : '',
          cpf: representative.cpf,
          rg: representative.rg,
          stateRg: representative.ufrg,
          birthday: representative.birthDate,
          zipCode: address && address.zipCode,
          address: address && address.street,
          number: address && address.number,
          complement: address && address.complement,
          district: address && address.neighborhood,
          city: address && address.city,
          country: address && address.country,
          state: address && address.uf
        }
      }) : [],
      responsibles: []
    }

    return company
  },

  validate (
    index,
    form,
    validations
  ) {
    let value = form[index]

    if (index === 'MediatorFee' && value) {
      value = Number(value.replaceAll('.', '').replaceAll(',', '.').replaceAll('R$ ', ''))
    }

    if (value) {
      switch (index) {
        case 'RazaoSocial':
          // eslint-disable-next-line no-case-declarations
          const hasInvalidChars = !(/^[a-zA-Z0-9.&\-\sçÇáéíóúãõâêîôûÀÁÂÃÄÈÉÊÌÍÎÒÓÔÙÚÜ]*$/).test(form[index])
          if (hasInvalidChars) {
            validations[index] = 'A razão social contém caracteres inválidos. Apenas letras, números, ".", "&" e "-" são permitidos.'
            return false
          }

          if (form[index].length > 150) {
            validations[index] = 'A razão social deve ter no máximo 150 caracteres.'
            return false
          }
          break

        case 'CNPJ':
          if (!cnpj.isValidMask(form[index])) {
            validations[index] = 'O formato do CNPJ não é válido.'
            return false
          }
          if (
            !cnpj.isValid(
              form[index]
                .replaceAll('/', '')
                .replaceAll('.', '')
                .replaceAll('-', '')
            )
          ) {
            validations[index] = 'O CNPJ não é válido.'
            return false
          }
          break

        case 'Email':
          if (!email.isValidMask(form[index])) {
            validations[index] = 'O formato do e-mail não é válido.'
            return false
          }
          if (form[index].length > 150) {
            validations[index] = 'O e-mail deve ter no máximo 150 caracteres.'
            return false
          }
          break

        case 'MediatorFee':
          // eslint-disable-next-line no-case-declarations
          const mediatorFee = form[index].replaceAll(
            '.',
            ''
          )
            .replaceAll(',', '.')
            .replaceAll('R$ ', '')
          // eslint-disable-next-line no-case-declarations
          const [digitsLeft, digitsRight] = mediatorFee.split('.')

          if (Number(mediatorFee) <= 0) {
            validations[index] = 'A tarifa padrão deve ser maior que zero.'
            return false
          }

          if ((digitsLeft && digitsLeft.length > 8) || (digitsRight && digitsRight.length > 2)) {
            validations[index] = 'A tarifa padrão deve ter no máximo 8 dígitos a esquerda e 2 a direita.'
            return false
          }
          break
      }

      console.log('validations', validations)
      delete validations[index]
      return true
    }
  },

  formatDataToMatera (data) {
    if (Array.isArray(data)) {
      data.map((representante) => {
        if (representante.Telefone) {
          representante.Telefone = representante.Telefone.replaceAll(' ', '')
            .replaceAll('(', '')
            .replaceAll(')', '')
            .replaceAll('-', '')
            .replaceAll('+55', '')
        }
        if (representante.Celular) {
          representante.Celular = representante.Celular.replaceAll(' ', '')
            .replaceAll('(', '')
            .replaceAll(')', '')
            .replaceAll('-', '')
            .replaceAll('+55', '')
        }
      })
    } else {
      if (data.Telefone) {
        data.Telefone = data.Telefone.replaceAll(' ', '')
          .replaceAll('(', '')
          .replaceAll(')', '')
          .replaceAll('-', '')
          .replaceAll('+55', '')
      }
      if (data.Celular) {
        data.Celular = data.Celular.replaceAll(' ', '')
          .replaceAll('(', '')
          .replaceAll(')', '')
          .replaceAll('-', '')
          .replaceAll('+55', '')
      }
    }
    return data
  },

  formatDataToDynamo (data) {
    const form = { ...data }

    form.empresa.CNPJ = form.empresa.CNPJ.replaceAll('-', '')
      .replaceAll('/', '')
      .replaceAll('.', '')
    form.empresa.CNAE = form.empresa.CNAE.toString()
      .replaceAll('-', '')
      .replaceAll('.', '')
      .replaceAll('/', '')
    form.empresa.Telefone = form.empresa.Telefone.replaceAll(' ', '')
    form.empresa.CEP = form.empresa.CEP.replaceAll('-', '')
    form.empresa.FaturamentoMensal = form.empresa.FaturamentoMensal.replaceAll(
      ',',
      ''
    )
      .replaceAll('.', '')
      .replaceAll('R$ ', '')

    form.representantes.forEach((representante) => {
      representante.CPF = representante.CPF.replaceAll('-', '').replaceAll(
        '.',
        ''
      )
      representante.RG = representante.RG.replaceAll('-', '')
      representante.Telefone = representante.Telefone.replaceAll(' ', '')
      representante.Celular = representante.Celular.replaceAll('-', '')
        .replaceAll('(', '')
        .replaceAll(')', '')
        .replaceAll(' ', '')
      representante.CEP = representante.CEP.replaceAll('-', '')
    })

    if (form.responsavel) {
      form.responsavel.CPF = form.responsavel.CPF.replaceAll(
        '-',
        ''
      ).replaceAll('.', '')
      form.responsavel.Celular = form.responsavel.Celular.replaceAll('-', '')
        .replaceAll('(', '')
        .replaceAll(')', '')
        .replaceAll(' ', '')
    } else {
      form.tecnico.responsavel.CPF = form.tecnico.responsavel.CPF.replaceAll(
        '-',
        ''
      ).replaceAll('.', '')
      form.tecnico.responsavel.Celular =
        form.tecnico.responsavel.Celular.replaceAll('-', '')
          .replaceAll('(', '')
          .replaceAll(')', '')
          .replaceAll(' ', '')

      form.tecnico.tecnico.CPF = form.tecnico.tecnico.CPF.replaceAll(
        '-',
        ''
      ).replaceAll('.', '')
      form.tecnico.tecnico.Celular = form.tecnico.tecnico.Celular.replaceAll(
        '-',
        ''
      )
        .replaceAll('(', '')
        .replaceAll(')', '')
        .replaceAll(' ', '')
    }

    return form
  },

  formatRepresentanteToSHOP (company, representative) {
    if (representative.Telefone) {
      representative.Telefone = representative.Telefone.replaceAll(' ', '')
        .replaceAll('(', '')
        .replaceAll(')', '')
        .replaceAll('-', '')
        .replaceAll('+55', '')
    }
    if (representative.Celular) {
      representative.Celular = representative.Celular.replaceAll(' ', '')
        .replaceAll('(', '')
        .replaceAll(')', '')
        .replaceAll('-', '')
        .replaceAll('+55', '')
    }
    return {
      cnpj: company.CNPJ,
      numero: representative.Numero,
      ufrg: representative.UFRG,
      dataNascimento: representative.DataNascimento,
      nomeMae: representative.NomeMae,
      bairro: representative.Bairro,
      endereco: representative.Endereco,
      complemento: representative.Complemento,
      cep: representative.CEP,
      cidade: representative.Cidade,
      uf: representative.UF,
      nome: representative.NomeCompleto,
      rg: representative.RG,
      cpf: representative.CPF,
      pais: representative.Pais,
      contatos: [
        {
          categoria: 'principal',
          valor: representative.Email,
          tipo: 'email'
        },
        {
          categoria: 'principal',
          valor: representative.Telefone,
          tipo: 'telefone'
        },
        {
          categoria: 'principal',
          valor: representative.Celular,
          tipo: 'celular'
        }
      ]
    }
  },

  formatResponsaveisToSHOP (company, responsavel, pessoaId) {
    return {
      cnpj: company.CNPJ,
      nome: responsavel.NomeCompleto,
      telefone: responsavel.Celular,
      celular: responsavel.Celular,
      email: responsavel.Email,
      cpf: responsavel.CPF,
      tipo: responsavel.tipo,
      status: true,
      pessoaId
    }
  },

  formatSHOPToSoftwareHouseData (shopData) {
    const companyData = shopData.person.juridicPerson
    const address = shopData.person.personAddresses[0].address
    const responsibles = shopData.person.contacts
    const representatives = companyData.legalRepresentatives.map((legalRepresentative) => legalRepresentative.physicalPerson)

    const softwareHouse = {
      corporateName: companyData.legalName,
      fantasyName: companyData.tradingName,
      cnpj: companyData.cnpj,
      openingDate: companyData.openingDate,
      cnae: companyData.cnae,
      companyConstituition: companyData.constitution,
      monthlyBilling: companyData.monthlyIncome,
      operationType: companyData.fieldOfActivity,
      taxRegime: companyData.taxRegime,
      isTaxExempt: companyData.exemptFromTax,
      stateRegistration: companyData.stateRegistration,
      zipCode: address.zipCode,
      address: address.street,
      number: address.number,
      district: address.neighborhood,
      complement: address.complement,
      city: address.city,
      country: address.country,
      state: address.uf,
      ibgeCode: address.ibgeCode,
      responsibles: responsibles ? responsibles.map((responsible) => {
        let role = 'financeiro'
        if (responsible.category === 'principal') {
          role = 'responsavel'
        } else if (responsible.category === 'responsavel_tecnico') {
          role = 'tecnico'
        }
        return {
          fullName: responsible.name,
          cellPhone: `+55${responsible.phone}`,
          email: responsible.email,
          role
        }
      }) : [],
      representatives: representatives ? representatives.map((representative) => {
        const address = representative.person.personAddresses[0] && representative.person.personAddresses[0].address
        const phoneContact = representative.person.contacts.find((contact) => contact.category === 'principal' && contact.phone)
        const emailContact = representative.person.contacts.find((contact) => contact.category === 'principal' && contact.email)
        return {
          fullName: representative.name,
          socialName: representative.assumedName,
          motherName: representative.motherName,
          phone: phoneContact ? `+55${phoneContact.phone}` : '',
          email: emailContact ? emailContact.email : '',
          cpf: representative.cpf,
          rg: representative.rg,
          stateRg: representative.ufrg,
          birthday: representative.birthDate,
          zipCode: address && address.zipCode,
          address: address && address.street,
          number: address && address.number,
          complement: address && address.complement,
          district: address && address.neighborhood,
          city: address && address.city,
          country: address && address.country,
          state: address && address.uf
        }
      }) : []
    }

    return softwareHouse
  },

  async getUF () {
    let UFs = []
    let data = await api.get(
      'https://servicodados.ibge.gov.br/api/v1/localidades/estados'
    )
    data = this.sort(data.data, 'sigla')
    UFs = data.map((UF) => (UF = UF.sigla))
    return UFs
  },

  sort (array, index) {
    return array.sort(function (first, second) {
      if (first[index] > second[index]) {
        return 1
      }
      if (first[index] < second[index]) {
        return -1
      }
      return 0
    })
  },

  checkUrl () {
    if (document.domain === 'admin.tecnopay.me') {
      return 'https://app.tecnopay.me'
    }
    if (document.domain === 'admin-sandbox.tecnopay.me') {
      return 'https://app-sandbox.tecnopay.me'
    }

    return 'http://localhost:8080'
  },

  base64ToBlob (base64) {
    const byteString = atob(base64.split(',')[1])
    const mimeString = base64.split(',')[0].split(':')[1].split(';')[0]

    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }

    return new Blob([ab], { type: mimeString })
  },

  openLinkToDownloadFile (blob, fileName) {
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }
}

export default utils
